import { Action } from "redux";

export const AUTH_LOGIN = "AUTH_LOGIN";

export interface AuthLoginAction extends Action {
  type: typeof AUTH_LOGIN;
  login: string;
  password: string;
}

export const authLoginAction = (
  login: string,
  password: string
): AuthLoginAction => ({
  type: AUTH_LOGIN,
  login,
  password,
});
